import EnterpriseAlexaSkillService from 'src/modules/enterpriseAlexaSkill/enterpriseAlexaSkillService';
import Errors from 'src/modules/shared/error/errors';
import Message from 'src/view/shared/message';
import { getHistory } from 'src/modules/store';
import { i18n } from 'src/i18n';

const prefix = 'ENTERPRISEALEXASKILL_FORM';

const enterpriseAlexaSkillFormActions = {
  INIT_STARTED: `${prefix}_INIT_STARTED`,
  INIT_SUCCESS: `${prefix}_INIT_SUCCESS`,
  INIT_ERROR: `${prefix}_INIT_ERROR`,

  CREATE_STARTED: `${prefix}_CREATE_STARTED`,
  CREATE_SUCCESS: `${prefix}_CREATE_SUCCESS`,
  CREATE_ERROR: `${prefix}_CREATE_ERROR`,

  UPDATE_STARTED: `${prefix}_UPDATE_STARTED`,
  UPDATE_SUCCESS: `${prefix}_UPDATE_SUCCESS`,
  UPDATE_ERROR: `${prefix}_UPDATE_ERROR`,

  doInit: (id) => async (dispatch) => {
    try {
      dispatch({
        type: enterpriseAlexaSkillFormActions.INIT_STARTED,
      });

      let record = {};

      const isEdit = Boolean(id);

      if (isEdit) {
        record = await EnterpriseAlexaSkillService.find(id);
      }

      dispatch({
        type: enterpriseAlexaSkillFormActions.INIT_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: enterpriseAlexaSkillFormActions.INIT_ERROR,
      });

      getHistory().push('/enterprise-alexa-skill');
    }
  },

  doCreate: (values) => async (dispatch) => {
    try {
      dispatch({
        type: enterpriseAlexaSkillFormActions.CREATE_STARTED,
      });

      await EnterpriseAlexaSkillService.create(values);

      dispatch({
        type: enterpriseAlexaSkillFormActions.CREATE_SUCCESS,
      });

      Message.success(
        i18n('entities.enterpriseAlexaSkill.create.success'),
      );

      getHistory().push('/enterprise-alexa-skill');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: enterpriseAlexaSkillFormActions.CREATE_ERROR,
      });
    }
  },

  doUpdate: (id, values) => async (dispatch, getState) => {
    try {
      dispatch({
        type: enterpriseAlexaSkillFormActions.UPDATE_STARTED,
      });

      await EnterpriseAlexaSkillService.update(id, values);

      dispatch({
        type: enterpriseAlexaSkillFormActions.UPDATE_SUCCESS,
      });

      Message.success(
        i18n('entities.enterpriseAlexaSkill.update.success'),
      );

      getHistory().push('/enterprise-alexa-skill');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: enterpriseAlexaSkillFormActions.UPDATE_ERROR,
      });
    }
  },
};

export default enterpriseAlexaSkillFormActions;
